(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.overlayTemplateOnlyAtTop = this.dataset.overlayTemplate === 'true';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.overlayTemplateOnlyAtTop) {
          requestAnimationFrame(this.hide.bind(this));
          this.currentScrollTop = scrollTop;
          return;
        }

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunster-countdown-announcement"] && !Shopify.designMode) return;
  try {
    
  class SunsterCountdownAnnouncement extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-announcement-track]');
      this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
      this.countdowns = Array.from(this.querySelectorAll('[data-countdown-slide]')).map((slide) =>
        this.createCountdown(slide)
      );
      this.countdownBySlide = new Map(this.countdowns.map((countdown) => [countdown.slide, countdown]));
      this.slideOffsets = new Map();
      this.rotationInterval = Math.max(Number(this.dataset.rotationInterval || 4), 2) * 1000;
      this.currentIndex = -1;
      this.activeSignature = '';

      if (!this.slides.length) {
        this.hidden = true;
        return;
      }

      this.prepareCascadeTexts();
      this.classList.add('is-enhanced');
      this.bindResponsiveHeight();
      this.tick();

      if (this.countdowns.length) {
        this.timerInterval = window.setInterval(() => this.tick(), 1000);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.timerInterval);
      window.clearInterval(this.rotationIntervalId);
      window.removeEventListener('resize', this.boundSyncSlideMeasurements);

      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    createCountdown(slide) {
      const copy = slide.querySelector('[data-countdown-copy]');
      const summary = slide.querySelector('[data-countdown-summary]');

      return {
        slide,
        copy,
        summary,
        startTime: this.parseDateTime(slide.dataset.startAt || ''),
        endTime: this.parseDateTime(slide.dataset.endAt || ''),
        hideWhenComplete: slide.dataset.hideWhenComplete === 'true',
        expiredText: slide.dataset.expiredText || '',
        completeLabel: slide.dataset.completeLabel || 'Countdown complete',
        originalText: copy ? copy.textContent.trim() : '',
        lastSummary: '',
        state: 'pending'
      };
    }

    parseDateTime(value) {
      const trimmedValue = value.trim();
      const readableMatch = trimmedValue.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/);

      if (readableMatch) {
        const [, year, month, day, hour, minute, second] = readableMatch;
        return new Date(
          Number(year),
          Number(month) - 1,
          Number(day),
          Number(hour),
          Number(minute),
          Number(second)
        ).getTime();
      }

      return Date.parse(trimmedValue);
    }

    prepareCascadeTexts() {
      this.querySelectorAll('[data-cascade-text]').forEach((cascadeText) => this.prepareCascadeText(cascadeText));
    }

    prepareCascadeText(cascadeText) {
      if (!cascadeText || cascadeText.dataset.prepared === 'true') return;

      const text = cascadeText.textContent.trim();
      cascadeText.textContent = '';

      let characterIndex = 0;

      text.split(' ').forEach((word, wordIndex, words) => {
        const wordElement = document.createElement('span');
        wordElement.className = 'sunster-countdown-announcement__word';

        Array.from(word).forEach((character) => {
          const span = document.createElement('span');
          span.className = 'sunster-countdown-announcement__char';
          span.style.setProperty('--char-index', characterIndex);
          span.textContent = character;
          wordElement.appendChild(span);
          characterIndex += 1;
        });

        cascadeText.appendChild(wordElement);

        if (wordIndex < words.length - 1) {
          cascadeText.appendChild(document.createTextNode(' '));
          characterIndex += 1;
        }
      });

      cascadeText.dataset.prepared = 'true';
    }

    bindResponsiveHeight() {
      this.boundSyncSlideMeasurements = () => this.syncSlideMeasurements();
      window.addEventListener('resize', this.boundSyncSlideMeasurements);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.boundSyncSlideMeasurements);
        this.slides.forEach((slide) => this.resizeObserver.observe(slide));
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.boundSyncSlideMeasurements);
      }

      this.syncSlideMeasurements();
    }

    getSlideHeight(slide) {
      if (!slide) return 0;

      return Math.ceil(slide.scrollHeight);
    }

    syncSlideMeasurements() {
      let offset = 0;
      this.slideOffsets.clear();

      this.slides.forEach((slide) => {
        this.slideOffsets.set(slide, offset);
        if (!slide.hidden) offset += this.getSlideHeight(slide);
      });

      this.updateTrackOffset();
      this.updateActiveHeight();
    }

    updateActiveHeight() {
      const activeSlide = this.slides[this.currentIndex];
      const activeHeight = this.getSlideHeight(activeSlide);

      if (activeHeight) {
        this.style.setProperty('--sunster-announcement-active-height', `${activeHeight}px`);
      }
    }

    updateTrackOffset() {
      const activeSlide = this.slides[this.currentIndex];
      const offset = this.slideOffsets.get(activeSlide) || 0;
      this.style.setProperty('--sunster-announcement-track-offset', `${offset}px`);
    }

    restartCascade(slide) {
      if (!slide) return;

      const characters = slide.querySelectorAll('.sunster-countdown-announcement__char');
      characters.forEach((character) => {
        character.style.animation = 'none';
      });

      this.offsetHeight;

      characters.forEach((character) => {
        character.style.animation = '';
      });
    }

    updateRotation() {
      window.clearInterval(this.rotationIntervalId);
      this.rotationIntervalId = null;

      const activeSlides = this.getActiveSlides();
      if (activeSlides.length <= 1) return;

      this.rotationIntervalId = window.setInterval(() => {
        this.advanceSlide();
      }, this.rotationInterval);
    }

    getActiveSlides() {
      return this.slides.filter((slide) => {
        if (!slide.hasAttribute('data-countdown-slide')) return true;

        const countdown = this.countdownBySlide.get(slide);
        return countdown && (countdown.state === 'active' || countdown.state === 'expired');
      });
    }

    refreshSlides() {
      const activeSlides = this.getActiveSlides();

      if (!activeSlides.length) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
      const activeSet = new Set(activeSlides);
      this.slides.forEach((slide) => {
        slide.hidden = !activeSet.has(slide);
      });

      this.syncSlideMeasurements();

      const currentSlide = this.slides[this.currentIndex];
      if (this.currentIndex < 0 || !currentSlide || currentSlide.hidden) {
        this.setSlide(activeSlides[0]);
      } else {
        this.updateTrackOffset();
        this.updateActiveHeight();
      }

      const signature = activeSlides.map((slide) => this.slides.indexOf(slide)).join(',');
      if (signature !== this.activeSignature) {
        this.activeSignature = signature;
        this.updateRotation();
      }
    }

    setSlide(target) {
      const slide = target instanceof Element ? target : this.slides[target];
      const index = this.slides.indexOf(slide);
      if (index < 0) return;

      this.currentIndex = index;
      const isCountdown = slide.hasAttribute('data-countdown-slide');

      this.slides.forEach((item, itemIndex) => {
        item.setAttribute('aria-hidden', itemIndex === index ? 'false' : 'true');
      });

      this.classList.toggle('is-countdown-active', isCountdown);
      this.classList.toggle('is-announcement-active', !isCountdown);
      this.syncSlideMeasurements();

      if (!isCountdown) this.restartCascade(slide);
    }

    advanceSlide() {
      const activeSlides = this.getActiveSlides();
      if (activeSlides.length <= 1) return;

      const currentSlide = this.slides[this.currentIndex];
      const currentPosition = activeSlides.indexOf(currentSlide);
      const nextSlide = activeSlides[(currentPosition + 1) % activeSlides.length];
      this.setSlide(nextSlide);
    }

    tick() {
      const now = Date.now();

      this.countdowns.forEach((countdown) => this.updateCountdown(countdown, now));
      this.refreshSlides();
    }

    updateCountdown(countdown, now) {
      if (Number.isNaN(countdown.endTime)) {
        countdown.state = 'hidden';
        return;
      }

      if (!Number.isNaN(countdown.startTime) && now < countdown.startTime) {
        countdown.state = 'pending';
        return;
      }

      const totalSeconds = Math.max(0, Math.floor((countdown.endTime - now) / 1000));

      if (totalSeconds <= 0) {
        this.completeCountdown(countdown);
        return;
      }

      countdown.state = 'active';
      if (countdown.copy && countdown.originalText) countdown.copy.textContent = countdown.originalText;

      const days = Math.min(99, Math.floor(totalSeconds / 86400));
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const digits = `${String(days).padStart(2, '0')}${String(hours).padStart(2, '0')}${String(minutes).padStart(2, '0')}${String(seconds).padStart(2, '0')}`;
      const digitMap = ['dayTens', 'dayOnes', 'hourTens', 'hourOnes', 'minuteTens', 'minuteOnes', 'secondTens', 'secondOnes'];

      digitMap.forEach((key, index) => this.updateDigit(countdown.slide, key, digits[index]));

      const summary = `${days} days ${hours} hours ${minutes} minutes ${seconds} seconds remaining`;
      if (summary !== countdown.lastSummary) {
        countdown.lastSummary = summary;
        if (countdown.summary) countdown.summary.textContent = summary;
      }
    }

    updateDigit(slide, key, value) {
      const digit = slide.querySelector(`[data-countdown-digit="${key}"]`);
      if (!digit || digit.textContent === value) return;

      digit.textContent = value;
      digit.classList.remove('is-ticking');
      digit.offsetHeight;
      digit.classList.add('is-ticking');
    }

    completeCountdown(countdown) {
      countdown.state = countdown.hideWhenComplete ? 'hidden' : 'expired';

      ['dayTens', 'dayOnes', 'hourTens', 'hourOnes', 'minuteTens', 'minuteOnes', 'secondTens', 'secondOnes'].forEach(
        (key) => this.updateDigit(countdown.slide, key, '0')
      );

      if (countdown.hideWhenComplete) {
        return;
      }

      if (countdown.copy && countdown.expiredText) countdown.copy.textContent = countdown.expiredText;
      if (countdown.summary) countdown.summary.textContent = countdown.completeLabel;
      this.syncSlideMeasurements();
    }
  }

  if (!customElements.get('sunster-countdown-announcement')) {
    customElements.define('sunster-countdown-announcement', SunsterCountdownAnnouncement);
  }

  } catch(e) { console.error(e); }
})();
})();
